import React from 'react';
import Validator from 'validatorjs';

import BussinesRulesForm from './BussinesRulesForm';

const AdditionalDataOnTicketStamping = (props) => {
  const { data = {}, bussines = [], onFormDataChange } = props;

  const getRules = () => {
    let newRules = {};

    bussines.forEach(function (elemento, indice, array) {
      newRules = {
        ...newRules,
        [elemento.name]: elemento.rules,
      };
    });

    const rules = {};

    return {
      ...rules,
      ...newRules,
    };
  };

  const handleOnChange = (event) => {
    const validator = new Validator(event, getRules());

    onFormDataChange({
      ...event,
      isValid: validator.passes(),
    });
  };

  return (
    <>
      {bussines.map((item) => (
        <BussinesRulesForm
          key={item.name}
          data={data}
          item={item}
          rules={getRules()}
          onChange={handleOnChange}
        />
      ))}
    </>
  );
};

export default AdditionalDataOnTicketStamping;
